import { Component } from "react";
import { Calendar as Calendar2 } from 'react-calendar';

import 'react-calendar/dist/Calendar.css';
import "./style.scss";

class Calendar extends Component {

    state = {
        date: null,
        show: false
    }

    componentDidMount() {
        window.addEventListener("click", this.hide);
        document.addEventListener("scroll", this.scrollHandler);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.hide);
        document.removeEventListener("scroll", this.scrollHandler);
    }

    componentDidUpdate() {
        this.updatePosition();
    }

    scrollHandler = (e) => {
        this.updatePosition();
    }

    updatePosition = () => {
        if (this.state.show) {
            let input = this.input;
            let calendar = input.querySelector(".react-calendar");
            let inputRect = input.getBoundingClientRect();
            let calendarRect = calendar.getBoundingClientRect();
            let x = inputRect.left;
            let y = inputRect.top + inputRect.height;
            x = Math.max(Math.min(x, window.innerWidth - calendarRect.width - 5), 5);
            y = Math.max(Math.min(y, window.innerHeight - calendarRect.height - 5), 5);
            calendar.setAttribute("style", `--x:${x}px;--y:${y}px`);

            if(inputRect.y>=window.innerHeight || inputRect.y<=-inputRect.height) this.setState({show:false})
        }
    }

    hide = () => {
        this.setState({ show: false })
    }

    render() {
        let { date, show } = this.state;
        return (
            <div ref={(t) => this.input = t} className="calendar" onClick={(e) => { e.stopPropagation() }}>
                {/* <input disabled type="date" id="birthday" name="birthday" /> */}
                <span>{date ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : this.props.hint}</span>
                <div className="hit" onClick={() => this.setState({ show: !show })}></div>
                <Calendar2 className={show ? "" : `hide`} onChange={(time) => { this.setState({ date: new Date(time) }); this.hide() }} value={date} />
            </div>
        )
    }
}

export default Calendar;